import React from "react"
export function Onward(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__Single-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M18.001 15.01v1.74h-16v-1.74h16zm-.53-11.55a.978.978 0 01-.217 1.537l-11.04 6.318a1.009 1.009 0 01-1.223-.17L3.768 9.89l11.718-6.706a1.64 1.64 0 011.985.276zM3.85 7.65l1.792 1.164-1.868 1.069L2 8.079l.8-.459a1.01 1.01 0 011.051.03zm3.422-5.484l4.64 3.06-2.67 1.528-3.98-4.076.953-.545a1.01 1.01 0 011.057.033z"
          fill="currentColor"
          id="prefix__onward"
        />
      </g>
    </svg>
  )
}
